import { useEffect } from "react";
import { API_OPTIONS } from "../utils/constants";
import { useDispatch, useSelector } from "react-redux";
import { addGenreIds } from "../utils/movieSlice";
import axios from "axios";

const useMovieGenreIds = () => {
  const dispatch = useDispatch();
  const moviesGenreIds = useSelector((store) => store.movies.moviesGenreIds);

  const url = "https://api.themoviedb.org/3/genre/movie/list";

  async function getGenreIds() {
    try {
      const response = await axios.get(url, API_OPTIONS);
      let responseOK = response && response.status === 200;

      if (responseOK) {
        const data = await response.data;
        dispatch(addGenreIds(data.genres));
      }
    } catch (error) {
      console.error(error);
    }
  }

  useEffect(() => {
    !moviesGenreIds && getGenreIds();
  }, []);
};

export default useMovieGenreIds;
